/*
 * VQ Zubehör-Slider (PDP)
 *
 * Der runde Plus-Button legt genau eine Variante über /cart/add.js in den
 * Warenkorb. Aktualisiert wird der Cart-Drawer bzw. die Cart-Notification des
 * Themes über deren bestehende renderContents()-Logik - wie beim
 * Cross-Selling, also keine zweite Warenkorb-Architektur.
 *
 * Produkte mit mehreren Varianten haben ein Auswahlfeld in der Karte. Die
 * Auswahl schreibt die Varianten-Id auf den Plus-Button und den Preis in
 * die Karte - gekauft wird also immer genau das, was dort steht.
 */
if (!customElements.get('vq-accessory-rail')) {
  customElements.define(
    'vq-accessory-rail',
    class VqAccessoryRail extends HTMLElement {
      connectedCallback() {
        this.errorEl = this.querySelector('[data-vqar-error]');
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-vqar-add]');
          if (!button || !this.contains(button)) return;
          event.preventDefault();
          this.addToCart(button);
        });

        this.addEventListener('change', (event) => {
          const select = event.target.closest('[data-vqar-variants]');
          if (!select || !this.contains(select)) return;
          this.selectVariant(select);
        });
      }

      /* ── Variantenwahl ──────────────────────────────────────────── */

      selectVariant(select) {
        const card = select.closest('.vq-ar__card');
        const option = select.options[select.selectedIndex];
        if (!card || !option) return;

        const button = card.querySelector('[data-vqar-add]');
        if (button) {
          button.dataset.variantId = option.value;
          // Ausverkaufte Varianten sind als option disabled und damit nicht
          // waehlbar - der Vollstaendigkeit halber trotzdem abgesichert.
          button.disabled = option.disabled;
        }

        const priceEl = card.querySelector('[data-vqar-price]');
        if (priceEl) priceEl.textContent = option.disabled ? card.dataset.soldoutLabel : option.dataset.price;

        const compareEl = card.querySelector('[data-vqar-compare]');
        if (compareEl) {
          compareEl.textContent = option.dataset.compare || '';
          compareEl.hidden = !option.dataset.compare || option.disabled;
        }
      }

      addToCart(button) {
        if (button.classList.contains('is-loading') || button.disabled) return;

        const id = Number(button.dataset.variantId);
        if (!id) return;

        this.hideError();
        button.classList.add('is-loading');
        button.setAttribute('aria-disabled', 'true');

        const body = { items: [{ id: id, quantity: 1 }] };

        if (this.cart) {
          body.sections = this.cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          this.cart.setActiveElement?.(button);
        }

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showError(response.description || response.message);
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'vq-accessory-rail',
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'vq-accessory-rail',
                cartData: response,
              });
            }

            this.cart.classList.remove('is-empty');
            this.cart.renderContents(response);
          })
          .catch((error) => {
            console.error(error);
            this.showError(this.dataset.errorGeneric);
          })
          .finally(() => {
            button.classList.remove('is-loading');
            button.removeAttribute('aria-disabled');
          });
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message || this.dataset.errorGeneric || '';
        this.errorEl.hidden = false;
      }

      hideError() {
        if (!this.errorEl) return;
        this.errorEl.hidden = true;
        this.errorEl.textContent = '';
      }
    }
  );
}
